const clientSatisfaction = {
    title: "Client Satisfaction Score",
    desc: "We appreciate your assistance in helping us enhance our services. Kindly complete the customer satisfaction survey and provide your comments to enable us to serve you better in the future.",
    score: {
      important: "Importance",
        score: "Score",
        total: "Total",
        suggestionsComments: "Suggestions / Comments",
    },
    criteria: {
        serviceQuality: "Service Quality",
        speedResponse: "Speed Response",
        compliance: "Compliance",
        definingRequests: "Defining Requests",
        financeDepartment: "Finance Department",
        priceTerms: "Price Terms",
        complaintResolution: "Complaint Resolution",
        complaintWay: "Complaint Way",
        attentionToDetail: "Attention to Detail",
    },
    placeholders: {
        writeDescription: "Write your description here...",
    }

}

export default clientSatisfaction;